import { render } from "./Preference.vue?vue&type=template&id=201af5e8&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"

import "./Preference.vue?vue&type=style&index=0&id=201af5e8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201af5e8"]])

export default __exports__